export default __webpack_public_path__ + "static/arabescosModal-aa9308427ce4ae556efd7025cd05b3fc.svg";